import React, { useEffect, useState } from 'react';
import Label from '../atoms/text/label';
import Text from '../atoms/text';
import { readSpreadsheetFile } from '../../utils/read-sheet';
import { NotificationToast } from './notification-toast';
import { useTranslation } from 'react-i18next';

interface SheetUploadProps {
	onSheetUpload: (data: any[][]) => void;
}

const SheetUpload = ({ onSheetUpload }: SheetUploadProps) => {
	const { t } = useTranslation();
	const [error, setError] = useState<string>('');

	useEffect(() => {
		if (!error) return;
		NotificationToast.Warn(error);
		setError('');
	}, [error]);

	// Função para manipular a alteração de arquivo via input
	const handleFileChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		const file = event.target.files?.[0];
		handleFileUpload(file);
	};

	const handleFileUpload = async (file?: File) => {
		if (!file) return;
		try {
			const result = await readSpreadsheetFile(file);
			if (!result || !result.data) return;
			onSheetUpload(result.data);
			setError('');
		} catch (err) {
			setError(t('alert.error.sheet'));
		}
	};

	// Funções para arrastar e soltar
	const handleDragOver = (event: React.DragEvent<HTMLLabelElement>) => {
		event.preventDefault(); // Necessário para permitir o "drop"
	};

	const handleDrop = (event: React.DragEvent<HTMLLabelElement>) => {
		event.preventDefault(); // Impede o comportamento padrão
		const file = event.dataTransfer.files[0];
		handleFileUpload(file);
	};

	return (
		<Label
			className="text-center flex flex-col items-center justify-center border-2 border-dashed border-gray-border rounded-md p-6 cursor-pointer transition-colors hover:border-primary group"
			htmlFor="sheet-upload"
			onDrag={handleDragOver}
			onDrop={handleDrop}
		>
			<input
				type="file"
				id="sheet-upload"
				accept=".xlsx,.xls,.csv"
				onChange={handleFileChange}
				className="hidden"
			/>
			<Text>{t('movement.sheet_upload')}</Text>
			<Text className="text-xs">
				{t('movement.formats_supported')}: .xlsx, .xls
			</Text>
		</Label>
	);
};

export default SheetUpload;
